import { render } from "./ua-markdown.vue?vue&type=template&id=06d9e442&scoped=true"
import script from "./ua-markdown.vue?vue&type=script&lang=js"
export * from "./ua-markdown.vue?vue&type=script&lang=js"

import "./ua-markdown.vue?vue&type=style&index=0&id=06d9e442&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d9e442"]])

export default __exports__